export default __webpack_public_path__ + "static/media/linkedin.679998b4.svg";